import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import Layout from '../components/Layout';

const Drivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingDriver, setEditingDriver] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    employee_type: 1,
    base_daily_rate: '',
    daily_rate_kablan: '',
    daily_rate_commercial: '',
    rate_per_km: '',
    rate_per_drop: '',
    client_drop_prices: [],
    sku_drop_prices: [],
    fabric_pricing_method: null,
    fabric_price_1_line: '',
    fabric_price_2_lines: '',
    fabric_price_per_pallet: '',
    active: true
  });

  useEffect(() => {
    loadDrivers();
  }, []);

  const loadDrivers = async () => {
    try {
      const response = await api.get('/drivers');
      setDrivers(response.data);
    } catch (error) {
      console.error('Error loading drivers:', error);
    }
  };

  const handleEdit = (driver) => {
    setEditingDriver(driver.id);
    setFormData({
      name: driver.name || '',
      phone: driver.phone || '',
      email: driver.email || '',
      employee_type: driver.employee_type || 1,
      base_daily_rate: driver.base_daily_rate || '',
      daily_rate_kablan: driver.daily_rate_kablan || driver.base_daily_rate || '',
      daily_rate_commercial: driver.daily_rate_commercial || driver.base_daily_rate || '',
      rate_per_km: driver.rate_per_km || '',
      rate_per_drop: driver.rate_per_drop || '',
      client_drop_prices: driver.client_drop_prices || [],
      sku_drop_prices: driver.sku_drop_prices || [],
      fabric_pricing_method: driver.fabric_pricing_method || null,
      fabric_price_1_line: driver.fabric_price_1_line || '',
      fabric_price_2_lines: driver.fabric_price_2_lines || '',
      fabric_price_per_pallet: driver.fabric_price_per_pallet || '',
      active: driver.active !== undefined ? driver.active : true // Preserve active status
    });
    setShowForm(true);
    // Scroll to top to show the form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        base_daily_rate: formData.base_daily_rate ? parseFloat(formData.base_daily_rate) : null,
        daily_rate_kablan: formData.daily_rate_kablan ? parseFloat(formData.daily_rate_kablan) : null,
        daily_rate_commercial: formData.daily_rate_commercial ? parseFloat(formData.daily_rate_commercial) : null,
        rate_per_km: formData.rate_per_km ? parseFloat(formData.rate_per_km) : null,
        rate_per_drop: formData.rate_per_drop ? parseFloat(formData.rate_per_drop) : null,
        client_drop_prices: formData.client_drop_prices.map(item => ({
          client_name: item.client_name,
          price_per_drop: parseFloat(item.price_per_drop)
        })),
        sku_drop_prices: formData.sku_drop_prices.map(item => ({
          sku: item.sku,
          price_per_drop: parseFloat(item.price_per_drop)
        })),
        fabric_pricing_method: formData.fabric_pricing_method || null,
        fabric_price_1_line: formData.fabric_price_1_line ? parseFloat(formData.fabric_price_1_line) : null,
        fabric_price_2_lines: formData.fabric_price_2_lines ? parseFloat(formData.fabric_price_2_lines) : null,
        fabric_price_per_pallet: formData.fabric_price_per_pallet ? parseFloat(formData.fabric_price_per_pallet) : null,
        active: formData.active !== undefined ? formData.active : true // Preserve active status
      };

      if (editingDriver) {
        await api.put(`/drivers/${editingDriver}`, payload);
        alert('נהג עודכן בהצלחה');
      } else {
        await api.post('/drivers', payload);
      alert('נהג נוסף בהצלחה');
      }
      
      setShowForm(false);
      setEditingDriver(null);
      resetForm();
      loadDrivers();
    } catch (error) {
      alert(error.response?.data?.error || 'שגיאה בשמירת נהג');
    }
  };

  const resetForm = () => {
      setFormData({
        name: '',
        phone: '',
        email: '',
      employee_type: 1,
        base_daily_rate: '',
        daily_rate_kablan: '',
        daily_rate_commercial: '',
        rate_per_km: '',
      rate_per_drop: '',
      client_drop_prices: [],
      sku_drop_prices: [],
      fabric_pricing_method: null,
      fabric_price_1_line: '',
      fabric_price_2_lines: '',
      fabric_price_per_pallet: '',
      active: true // Default to active for new drivers
    });
  };

  const handleDelete = async (id) => {
    if (window.confirm('האם למחוק נהג זה?')) {
      try {
        await api.delete(`/drivers/${id}`);
        alert('נהג נמחק');
        // Refresh drivers list after deletion
        await loadDrivers();
      } catch (error) {
        alert(error.response?.data?.error || 'שגיאה במחיקת נהג');
      }
    }
  };

  const handleToggleActive = async (id) => {
    try {
      await api.patch(`/drivers/${id}/toggle-active`);
      // Refresh drivers list after toggle
      await loadDrivers();
    } catch (error) {
      alert(error.response?.data?.error || 'שגיאה בעדכון סטטוס נהג');
    }
  };

  const addClientPrice = () => {
    setFormData({
      ...formData,
      client_drop_prices: [...formData.client_drop_prices, { client_name: '', price_per_drop: '' }]
    });
  };

  const removeClientPrice = (index) => {
    setFormData({
      ...formData,
      client_drop_prices: formData.client_drop_prices.filter((_, i) => i !== index)
    });
  };

  const updateClientPrice = (index, field, value) => {
    const updated = [...formData.client_drop_prices];
    updated[index] = { ...updated[index], [field]: value };
    setFormData({ ...formData, client_drop_prices: updated });
  };

  const addSkuPrice = () => {
    setFormData({
      ...formData,
      sku_drop_prices: [...formData.sku_drop_prices, { sku: '', price_per_drop: '' }]
    });
  };

  const removeSkuPrice = (index) => {
    setFormData({
      ...formData,
      sku_drop_prices: formData.sku_drop_prices.filter((_, i) => i !== index)
    });
  };

  const updateSkuPrice = (index, field, value) => {
    const updated = [...formData.sku_drop_prices];
    updated[index] = { ...updated[index], [field]: value };
    setFormData({ ...formData, sku_drop_prices: updated });
  };

  const getEmployeeTypeLabel = (type) => {
    if (type === 1) return 'קבלן משנה';
    if (type === 2) return 'נהג מסחרית';
    if (type === 3) return 'שכיר';
    return 'לא ידוע';
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold text-nexolog-navy">ניהול נהגים</h1>
          <button
            onClick={() => {
              resetForm();
              setEditingDriver(null);
              setShowForm(!showForm);
            }}
            className="bg-green-500 hover:bg-green-600 text-white font-medium px-6 py-3 rounded-lg transition-colors"
          >
            + הוסף נהג חדש
          </button>
        </div>

        {/* Add/Edit Driver Form */}
        {showForm && (
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-4">{editingDriver ? 'ערוך נהג' : 'נהג חדש'}</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Basic Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">שם *</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">סוג נהג *</label>
                  <select
                    value={formData.employee_type}
                    onChange={(e) => setFormData({...formData, employee_type: parseInt(e.target.value)})}
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                    required
                  >
                    <option value={1}>קבלן משנה</option>
                    <option value={2}>נהג מסחרית</option>
                    <option value={3}>שכיר</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">טלפון</label>
                  <input
                    type="text"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">אימייל</label>
                  <input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                  />
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="active"
                    checked={formData.active !== undefined ? formData.active : true}
                    onChange={(e) => setFormData({...formData, active: e.target.checked})}
                    className="h-4 w-4 text-nexolog-teal focus:ring-nexolog-teal border-gray-300 rounded"
                  />
                  <label htmlFor="active" className="mr-2 block text-sm font-medium text-gray-700">
                    נהג פעיל
                  </label>
                </div>
              </div>

              {/* Pricing Fields - All shown for all drivers */}
              <div className="border-t pt-4">
                <h3 className="text-lg font-semibold mb-4">תמחור</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      תעריף יומי קבלן משנה (₪)
                      <span className="text-xs text-gray-500 block mt-1">למסלולי משאית</span>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.daily_rate_kablan}
                      onChange={(e) => setFormData({...formData, daily_rate_kablan: e.target.value})}
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                      placeholder="750.00"
                    />
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      תעריף יומי נהג מסחרית (₪)
                      <span className="text-xs text-gray-500 block mt-1">למסלולי מסחרית</span>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.daily_rate_commercial}
                      onChange={(e) => setFormData({...formData, daily_rate_commercial: e.target.value})}
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                      placeholder="850.00"
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">מחיר לק"מ (₪)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.rate_per_km}
                      onChange={(e) => setFormData({...formData, rate_per_km: e.target.value})}
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                      placeholder="1.90"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">מחיר לדרופ (₪)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.rate_per_drop}
                      onChange={(e) => setFormData({...formData, rate_per_drop: e.target.value})}
                      className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                      placeholder="20.00"
                    />
                  </div>
                </div>
              </div>

              {/* Fabric Pricing (פבריק) */}
              <div className="border-t pt-4">
                <h3 className="text-lg font-semibold mb-4">תמחור פבריק</h3>
                <div className="bg-purple-50 p-4 rounded-lg">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    מחיר קבוע לקו פבריק (₪)
                    <span className="text-xs text-gray-500 block mt-1">מחיר קבוע לכל קו במסלול פבריק</span>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.fabric_price_1_line}
                    onChange={(e) => setFormData({...formData, fabric_price_1_line: e.target.value})}
                    className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                    placeholder="1100.00"
                  />
                </div>
              </div>

              {/* Client-Specific Drop Prices */}
              <div className="border-t pt-4">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold">מחירי דרופ לפי לקוח</h3>
                  <button
                    type="button"
                    onClick={addClientPrice}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm"
                  >
                    + הוסף לקוח
                  </button>
                </div>
                {formData.client_drop_prices.map((item, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3 p-3 bg-gray-50 rounded-lg">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">שם לקוח</label>
                      <input
                        type="text"
                        value={item.client_name}
                        onChange={(e) => updateClientPrice(index, 'client_name', e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                        placeholder="שם הלקוח"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">מחיר לדרופ (₪)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={item.price_per_drop}
                        onChange={(e) => updateClientPrice(index, 'price_per_drop', e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                        placeholder="0.00"
                      />
                    </div>
                    <div className="flex items-end">
                      <button
                        type="button"
                        onClick={() => removeClientPrice(index)}
                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg w-full"
                      >
                        מחק
                      </button>
                    </div>
                  </div>
                ))}
                {formData.client_drop_prices.length === 0 && (
                  <p className="text-gray-500 text-sm">אין מחירי לקוחות מותאמים אישית</p>
                )}
              </div>

              {/* SKU-Specific Drop Prices */}
              <div className="border-t pt-4">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold">מחירי דרופ לפי SKU</h3>
                  <button
                    type="button"
                    onClick={addSkuPrice}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm"
                  >
                    + הוסף SKU
                  </button>
                </div>
                {formData.sku_drop_prices.map((item, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3 p-3 bg-gray-50 rounded-lg">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">SKU</label>
                      <input
                        type="text"
                        value={item.sku}
                        onChange={(e) => updateSkuPrice(index, 'sku', e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                        placeholder="קוד SKU"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">מחיר לדרופ (₪)</label>
                      <input
                        type="number"
                        step="0.01"
                        value={item.price_per_drop}
                        onChange={(e) => updateSkuPrice(index, 'price_per_drop', e.target.value)}
                        className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-nexolog-teal"
                        placeholder="0.00"
                      />
                    </div>
                    <div className="flex items-end">
                      <button
                        type="button"
                        onClick={() => removeSkuPrice(index)}
                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg w-full"
                      >
                        מחק
                      </button>
                    </div>
                  </div>
                ))}
                {formData.sku_drop_prices.length === 0 && (
                  <p className="text-gray-500 text-sm">אין מחירי SKU מותאמים אישית</p>
                )}
              </div>

              <div className="flex gap-4 pt-4 border-t">
                <button
                  type="submit"
                  className="bg-nexolog-teal hover:bg-nexolog-teal/90 text-white px-6 py-2 rounded-lg"
                >
                  שמור
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowForm(false);
                    setEditingDriver(null);
                    resetForm();
                  }}
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-2 rounded-lg"
                >
                  ביטול
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Drivers Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">שם</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">סוג נהג</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">טלפון</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">תמחור</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">סטטוס</th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">פעולות</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {drivers.map((driver) => (
                <tr key={driver.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{driver.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {getEmployeeTypeLabel(driver.employee_type || 1)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{driver.phone || '-'}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">
                    <div className="flex flex-col gap-1">
                      {driver.daily_rate_kablan && (
                        <div className="text-xs">
                          <span className="font-medium text-blue-600">קבלן:</span> {driver.daily_rate_kablan}₪
                        </div>
                      )}
                      {driver.daily_rate_commercial && (
                        <div className="text-xs">
                          <span className="font-medium text-green-600">מסחרי:</span> {driver.daily_rate_commercial}₪
                        </div>
                      )}
                      {driver.rate_per_km && (
                        <div className="text-xs text-gray-600">ק"מ: {driver.rate_per_km}₪</div>
                      )}
                      {driver.rate_per_drop && (
                        <div className="text-xs text-gray-600">דרופ: {driver.rate_per_drop}₪</div>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <button
                      onClick={() => handleToggleActive(driver.id)}
                      className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                        (driver.active !== undefined ? driver.active : true)
                          ? 'bg-green-500 text-white hover:bg-green-600' 
                          : 'bg-red-500 text-white hover:bg-red-600'
                      }`}
                      title={(driver.active !== undefined ? driver.active : true) ? 'לחץ להפוך ללא פעיל' : 'לחץ להפוך לפעיל'}
                    >
                      {(driver.active !== undefined ? driver.active : true) ? '✓ פעיל' : '✗ לא פעיל'}
                    </button>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2">
                    <button
                      onClick={() => handleEdit(driver)}
                      className="text-blue-600 hover:text-blue-900"
                    >
                      ערוך
                    </button>
                    <button
                      onClick={() => handleDelete(driver.id)}
                      className="text-red-600 hover:text-red-900"
                    >
                      מחק
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default Drivers;
